<template>
  <div class="product-tag-chantier">
    <select-tag-chantier
      :display="selectTagDisplay"
      :id-panier="idPanier"
      :cart-row-id="cartRowId"
      :selected-tag="selectedTag"
      :tag-list="mainTagList"
      :label-create-tag="labelCreateTag"
      :label-choose-tag="labelChooseTag"
      @add-tag="showAddTag"
      @select-tag="setTag($event)"
      @tag-selected="clearSelectedTag"
    />
    <add-tag-chantier
      :display="addTagDisplay"
      :cart-row-id="cartRowId"
      :placeholder-tag="placeholderTag"
      @validate-add-tag="setTag($event)"
      @cancel-add-tag="hideAddTag"
    />
  </div>
</template>
<script>
import AddTagChantier from './AddTagChantier.vue'
import SelectTagChantier from './SelectTagChantier.vue'
import axios from 'axios'

export default {
  components: { AddTagChantier, SelectTagChantier },
  props: {
    idPanier: {
      type: String,
      default: ''
    },
    cartRowId: {
      type: String,
      default: ''
    },
    mainTagList: {
      type: Array,
      default() {
        return []
      }
    },
    labelCreateTag: {
      type: String,
      default: ''
    },
    labelChooseTag: {
      type: String,
      default: ''
    },
    placeholderTag: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      selectedTag: null,
      selectTagDisplay: 'flex',
      addTagDisplay: 'none'
    }
  },
  methods: {
    postTag: function(cartRowId, tagName) {
      let tagChantier = {
        id: cartRowId,
        tagName: tagName
      }
      return new Promise((resolve, reject) => {
        axios.post('/tag/chantier/', tagChantier).then(
          response => {
            resolve(response.data)
          },
          response => {
            reject(response)
          }
        )
      })
    },
    clearSelectedTag: function() {
      this.selectedTag = null
    },
    showAddTag: function() {
      this.selectTagDisplay = 'none'
      this.addTagDisplay = 'flex'
    },
    hideAddTag: function() {
      this.selectTagDisplay = 'flex'
      this.addTagDisplay = 'none'
    },
    setTag: function(args) {
      let tagInfo = {
        cartRowId: args[0],
        tagName: args[1],
        new: args[2]
      }
      this.postTag(tagInfo.cartRowId, tagInfo.tagName).then(
        response => {
          if(tagInfo.new) {
            this.$emit('tag-added')
            if (tagInfo.tagName) {
              this.selectedTag = tagInfo.tagName
            }
            this.hideAddTag()
          }
        },
        response =>
          console.log(
            'Error - set tagChantier: ' + JSON.stringify(response)
          )
      )
    }
  }
}
</script>
<style scoped>
  .caddieLineShort .product-tag-chantier {
    display: none;
  }
</style>
